$(function() {
    var modal = $('.timeline-modal__overlay');
    var modalTitle = $('.timeline-modal__title');
    var modalContent = $('.timeline-modal__body');
    var modalClose = $('.timeline-modal__close');
    var audio = "/click.ogg";

    $('.section-item').click(function(){
        var title = $(this).data('title');
        var content = $(this).data('content');

        modalTitle.html(title);
        modalContent.html(content);

        if (typeof title !== 'undefined') {
            new Audio(audio).play();  
            modal.addClass('timeline-modal__overlay--active');
        }
    });

    modalClose.click(function(){
        modal.removeClass('timeline-modal__overlay--active');
    });

    // $('.section-name').stickybits({
    //     useStickyClasses: true
    // });
});
